import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateData',
  standalone: true,
})
export class TranslateDataPipe implements PipeTransform {
  transform<T>(data: T[], translationKey: keyof T, dictionary: Record<string, string>): T[] {
    return data.map((item) => {
      return {
        ...item,
        [translationKey]: dictionary[item[translationKey] as string] || item[translationKey],
      };
    });
  }
}
